// Shared TanStack Query options for the BKLS marketplace.
// Kept out of route files so any route can import them without pulling in
// another route module.
import { queryOptions } from "@tanstack/react-query";
import { getBklsSettings, listBeatCollections, listLicenseTiers } from "@/lib/bkls.functions";
import { getBeatEngagement, getBeatWaveform, listMarketplaceBeats } from "@/lib/bkls-marketplace.functions";

export const beatsSettingsQuery = queryOptions({
  queryKey: ["bkls", "settings"],
  queryFn: () => getBklsSettings(),
});

export const beatsTiersQuery = queryOptions({
  queryKey: ["bkls", "tiers"],
  queryFn: () => listLicenseTiers(),
});

export const beatsCatalogQuery = queryOptions({
  queryKey: ["bkls", "marketplace", "beats"],
  queryFn: () => listMarketplaceBeats(),
});

export const beatsEngagementQuery = queryOptions({
  queryKey: ["bkls", "marketplace", "engagement"],
  queryFn: () => getBeatEngagement(),
  staleTime: 5 * 60_000,
});

export const beatCollectionsQuery = queryOptions({
  queryKey: ["bkls", "collections"],
  queryFn: () => listBeatCollections(),
});

export const beatWaveformQuery = (slug: string) =>
  queryOptions({
    queryKey: ["bkls", "waveform", slug],
    queryFn: () => getBeatWaveform({ data: { slug } }),
    staleTime: 60 * 60_000,
  });
